import { AnchorHTMLAttributes, MouseEvent as ReactMouseEvent } from "react"
import { Link, useParams } from "react-router-dom"
import { stringify } from "querystringify"

import { getCurrentStatus } from "app/AppRouter/utils"
import { FunnelStorage, isAllowedToBeBookingSource } from "modules/FunnelAnalytics"
import { useTabletOrMobile } from "utils/hooks"
import { APP_STATUSES } from "utils/AppStatusContext"

interface ProfileLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    profileUrl: string
    resultsKey?: string | null
    position?: string
    replace?: boolean
    enableAudio?: boolean
    from?: APP_STATUSES
    fromLink?: string
    showPsysStory?: number
}

export function ProfileLink({
    resultsKey,
    position = "1",
    children,
    from,
    onClick,
    profileUrl,
    fromLink,
    showPsysStory,
    ...props
}: ProfileLinkProps) {
    const currentStatus = getCurrentStatus()
    const pathParams = useParams<{ id: string }>()
    const isTabletOrMobile = useTabletOrMobile()

    const urlParams: Record<string, string | string[]> = {
        position,
    }
    if (resultsKey) {
        urlParams.results_key = resultsKey
    }
    if (from !== undefined) {
        urlParams.from = from.toString()
    }
    if (fromLink) {
        urlParams.from_link = fromLink.toString()
    }
    if (showPsysStory) {
        urlParams.show_psys_story = showPsysStory.toString()
    }

    function clickHandler(event: ReactMouseEvent<HTMLAnchorElement, MouseEvent>) {
        onClick?.(event)
        if (currentStatus && isAllowedToBeBookingSource(currentStatus)) {
            FunnelStorage.getInstance().saveItem(
                currentStatus,
                currentStatus === APP_STATUSES.psy_collection ? pathParams.id : undefined
            )
        }
    }

    // SurveyResultsHandlerProvide из PsyProfileClient.tsx r нужно перенести в App.js, после этого удалить хак (https://app.clickup.com/t/25xrrdn)
    const HyperlinkTag =
        currentStatus === APP_STATUSES.survey_results && isTabletOrMobile ? "a" : Link
    return (
        // @ts-expect-error TS2322: Property 'children' does not exist on type 'IntrinsicAttributes
        <HyperlinkTag
            rel="opener"
            onClick={clickHandler}
            {...props}
            {...{
                [HyperlinkTag === "a" ? "href" : "to"]: `${profileUrl}?${stringify(urlParams)}`,
            }}
        >
            {children}
        </HyperlinkTag>
    )
}
